import Vue from 'vue'
import axios from 'axios'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

// Make Axios play nice with Django CSRF
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
  state: {
    authUser: localStorage.getItem('useridLocal') ? {
      id: localStorage.getItem('useridLocal'),
      username: localStorage.getItem('username'),
      first_name: localStorage.getItem('firstName'),
      last_name: localStorage.getItem('lastName'),
      role_name: localStorage.getItem('userRole'),
    } : {},
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
    jwt: localStorage.getItem('token'),
    endpoints: {
      baseUrl: `${process.env.VUE_APP_ROOT_API}/`,
      signinURL: `${process.env.VUE_APP_ROOT_API}/signin/`,
      obtainJWT: `${process.env.VUE_APP_ROOT_API}/token-obtain/`,
      refreshJWT: `${process.env.VUE_APP_ROOT_API}/token-refresh/`,
      logoutURL: `${process.env.VUE_APP_ROOT_API}/logout/`,
      passwordResetEmailURL: `${process.env.VUE_APP_ROOT_API}/password-reset-send-email/`,
      passwordResetURL: `${process.env.VUE_APP_ROOT_API}/password-reset/`,
    },
  },
  mutations: {
    setAuthUser(state, {
      authUser,
      isAuthenticated,
    }) {
      Vue.set(state, 'authUser', authUser)
      Vue.set(state, 'isAuthenticated', isAuthenticated)
    },
    updateToken(state, newToken) {
      // TODO: For security purposes, take localStorage out of the project.
      localStorage.setItem('token', newToken)
      state.jwt = newToken
    },
    removeToken(state) {
      // TODO: For security purposes, take localStorage out of the project.
      localStorage.removeItem('token')
      localStorage.removeItem('useridLocal')
      localStorage.removeItem('username')
      localStorage.removeItem('firstName')
      localStorage.removeItem('lastName')
      localStorage.removeItem('userRole')
      localStorage.removeItem('isAuthenticated')
      localStorage.removeItem('pageAccessesNames')
      state.jwt = null
      state.authUser = {}
      state.isAuthenticated = false
    },
  },
})
